import { PREGNANCY_OUTCOME } from './config';

// Bridge between the FHQ pregnancy shape and the Bennett/pedigree shape. Pregnancies live in
// ONE shared collection (Pregnancy base = FHQ writes, PregnancyChanged = pedigree/clinician
// writes, merged on read), but the FHQ historically stored a legacy outcome vocabulary and a
// couple of differently-named fields. These pure helpers normalise a record on READ so a
// patient-entered pregnancy renders correctly without a destructive data migration. Bennett
// values pass through unchanged, so records authored by the pedigree editor are untouched.

// Legacy FHQ outcome values → Bennett enum (config.PREGNANCY_OUTCOME).
const LEGACY_OUTCOME = {
  delivered: PREGNANCY_OUTCOME.liveBirth,
  miscarriage: PREGNANCY_OUTCOME.sab,
  termination: PREGNANCY_OUTCOME.top,
  stillbirth: PREGNANCY_OUTCOME.stillbirth
};

// Map a stored outcome (legacy OR Bennett) to the Bennett enum. Unknown / already-Bennett
// values pass through. Used by the render derivation AND the FHQ display consumers so a
// stored `delivered` reads as a live birth everywhere.
export function normalizePregnancyOutcome(outcome) {
  if (outcome == null) return outcome;
  return LEGACY_OUTCOME[outcome] || outcome;
}

const isMultiple = (v) =>
  v === true || v === 'yes' || v === 'Yes' || v === 'true';

// Reconcile a pregnancy record to the shape deriveReproNodes expects: normalise the outcome
// and fill the render field names the FHQ stores under different keys
// (completedWeeks→gestationalWeeks, twins_triplets→multiplicity). Non-destructive — returns a
// shallow copy and never drops the original fields (so FHQ display code that still reads
// completedWeeks keeps working).
export function normalizePregnancyRecord(rec) {
  if (!rec || typeof rec !== 'object') return rec;
  const gestationalWeeks =
    rec.gestationalWeeks != null && rec.gestationalWeeks !== ''
      ? rec.gestationalWeeks
      : rec.completedWeeks;
  const multiplicity =
    rec.multiplicity != null
      ? rec.multiplicity
      : isMultiple(rec.twins_triplets)
      ? 2
      : undefined;
  return {
    ...rec,
    outcome: normalizePregnancyOutcome(rec.outcome),
    ...(gestationalWeeks != null && gestationalWeeks !== ''
      ? { gestationalWeeks }
      : {}),
    ...(multiplicity != null ? { multiplicity } : {})
  };
}
